export enum AppRoutes {
  HOME = '/',

  AUTH = '/auth',
  SIGN_IN = '/auth/sign-in',
  SIGN_UP = '/auth/sign-up',
  SIGN_UP_CONFIRM_EMAIL = '/auth/this-is-our-very-secret-backdoor-sign-up-link/confirm-email',
  RESET_PASSWORD = '/auth/reset-password',
  RESET_PASSWORD_CONFIRM = '/auth/reset-password/confirm',
  MISSING_PASSWORD_SIGN_IN = '/auth/sign-in-with-missing-password',
  ONE_TIME_CODE_SIGN_IN = '/auth/sign-in-with-one-time-code',
  TWO_FACTOR_SIGN_IN = '/auth/two-factor',
  CONFIRM_EMAIL_CHANGE = '/auth/confirm-email-change',
  TEAM_INVITE = '/auth/team-invite',

  DASHBOARD = '/dashboard',
  INVESTOR_PORTFOLIO = '/portfolio/:tab(homes|buildings)?',
  INVESTOR_PORTFOLIO_MANAGE = '/portfolio/manage',
  INVESTOR_AVAILABILITY = '/availability',
  INVESTOR_SHOWINGS = '/showings',
  INVESTOR_CALENDAR = '/calendar',
  INVESTOR_PROFILE = '/profile',
  INVESTOR_INTEGRATIONS = '/integrations',
  INVESTOR_INTEGRATION_DETAILS = '/integrations/:integrationId',

  INVESTOR_ONBOARDING = '/onboarding',

  INVESTOR_PROPERTY = '/property/:propertyId',
  INVESTOR_PROPERTY_DETAILS = '/property/:propertyId/details',
  INVESTOR_PROPERTY_DASHBOARD = '/property/:propertyId/dashboard',
  INVESTOR_PROPERTY_SHOWINGS = '/property/:propertyId/showings',
  INVESTOR_PROPERTY_SHOWING_DETAILS = '/property/showings/:showingId',
  INVESTOR_PROPERTY_LEADS = '/property/:propertyId/leads',
  INVESTOR_PROPERTY_APPLICATIONS = '/property/:propertyId/applications',
  INVESTOR_PROPERTY_AVAILABILITY = '/property/:propertyId/availability',
  INVESTOR_PROPERTY_TEAM = '/property/:propertyId/team',
  INVESTOR_PROPERTY_RENTER_PROFILE = '/property/:propertyId/renter/profile/:renterId',
  INVESTOR_PROPERTY_RENTER_PROFILE_APPLICATION_REVIEW = '/property/:propertyId/renter/profile/:renterId/application/:applicationId',
  INVESTOR_PROPERTY_ONBOARDING = '/property/onboarding/:propertyId',
  INVESTOR_PROPERTY_ONBOARDING_AVAILABILITY = '/property/onboarding/:propertyId/availability',
  INVESTOR_NEW_BUILDING = '/listing/new/building',
  INVESTOR_BUILDING = '/building/:buildingId',
  INVESTOR_BUILDING_UNITS = '/building/:buildingId/units',
  INVESTOR_BUILDING_DETAILS = '/building/:buildingId/details',
  INVESTOR_BUILDING_TEAM = '/building/:buildingId/team',
  APPLICATION_REPORT = '/application/:applicationId/report/:reportType',

  DEV_TOOLS = '/dev-tools',

  NOT_FOUND = '/:pathMatch(.*)*',
}

export enum AppRouteNames {
  INVESTOR_PROPERTY_ONBOARDING_OVERVIEW = 'INVESTOR_PROPERTY_ONBOARDING_OVERVIEW',
  INVESTOR_PROPERTY_ONBOARDING_AVAILABILITY = 'INVESTOR_PROPERTY_ONBOARDING_AVAILABILITY',

  INVESTOR_ONBOARDING = 'INVESTOR_ONBOARDING',
  INVESTOR_ONBOARDING_WELCOME = 'INVESTOR_ONBOARDING_WELCOME',
  INVESTOR_ONBOARDING_ACCOUNT_TYPE = 'INVESTOR_ONBOARDING_ACCOUNT_TYPE',
  INVESTOR_ONBOARDING_COMPANY_INFO = 'INVESTOR_ONBOARDING_COMPANY_INFO',
  INVESTOR_ONBOARDING_INVITE_TEAM = 'INVESTOR_ONBOARDING_INVITE_TEAM',
  INVESTOR_ONBOARDING_RENTAL_STRATEGY = 'INVESTOR_ONBOARDING_RENTAL_STRATEGY',
  INVESTOR_ONBOARDING_CONNECT_CALENDAR = 'INVESTOR_ONBOARDING_CONNECT_CALENDAR',
  INVESTOR_ONBOARDING_COMMUNICATION = 'INVESTOR_ONBOARDING_COMMUNICATION',
  INVESTOR_ONBOARDING_FINISH = 'INVESTOR_ONBOARDING_FINISH',

  HOME = 'HOME',
  DASHBOARD = 'DASHBOARD',
  SIGN_IN = 'SIGN_IN',
  SIGN_UP = 'SIGN_UP',
  SIGN_UP_CONFIRM_EMAIL = 'SIGN_UP_CONFIRM_EMAIL',
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_PASSWORD_CONFIRM = 'RESET_PASSWORD_CONFIRM',
  MISSING_PASSWORD_SIGN_IN = 'MISSING_PASSWORD_SIGN_IN',
  ONE_TIME_CODE_SIGN_IN = 'ONE_TIME_CODE_SIGN_IN',
  TWO_FACTOR_SIGN_IN = 'TWO_FACTOR_SIGN_IN',
  CONFIRM_EMAIL_CHANGE = 'CONFIRM_EMAIL_CHANGE',
  TEAM_INVITE = 'TEAM_INVITE',
  INVESTOR_PORTFOLIO = 'INVESTOR_PORTFOLIO',
  INVESTOR_PORTFOLIO_MANAGE = 'INVESTOR_PORTFOLIO_MANAGE',
  INVESTOR_AVAILABILITY = 'INVESTOR_AVAILABILITY',
  INVESTOR_SHOWINGS = 'INVESTOR_SHOWINGS',
  INVESTOR_CALENDAR = 'INVESTOR_CALENDAR',
  INVESTOR_PROFILE = 'INVESTOR_PROFILE',
  INVESTOR_INTEGRATIONS = 'INVESTOR_INTEGRATIONS',
  INVESTOR_INTEGRATION_DETAILS = 'INVESTOR_INTEGRATION_DETAILS',
  INVESTOR_PROPERTY = 'INVESTOR_PROPERTY',
  INVESTOR_PROPERTY_DETAILS = 'INVESTOR_PROPERTY_DETAILS',
  INVESTOR_PROPERTY_DASHBOARD = 'INVESTOR_PROPERTY_DASHBOARD',
  INVESTOR_PROPERTY_SHOWINGS = 'INVESTOR_PROPERTY_SHOWINGS',
  INVESTOR_PROPERTY_SHOWING_DETAILS = 'INVESTOR_PROPERTY_SHOWING_DETAILS',
  INVESTOR_PROPERTY_LEADS = 'INVESTOR_PROPERTY_LEADS',
  INVESTOR_PROPERTY_APPLICATIONS = 'INVESTOR_PROPERTY_APPLICATIONS',
  INVESTOR_PROPERTY_AVAILABILITY = 'INVESTOR_PROPERTY_AVAILABILITY',
  INVESTOR_PROPERTY_TEAM = 'INVESTOR_PROPERTY_TEAM',
  INVESTOR_PROPERTY_RENTER_PROFILE = 'INVESTOR_PROPERTY_RENTER_PROFILE',
  INVESTOR_PROPERTY_RENTER_PROFILE_APPLICATION_REVIEW = 'INVESTOR_PROPERTY_RENTER_PROFILE_APPLICATION_REVIEW',
  INVESTOR_PROPERTY_ONBOARDING = 'INVESTOR_PROPERTY_ONBOARDING',
  INVESTOR_NEW_BUILDING = 'INVESTOR_NEW_BUILDING',
  INVESTOR_BUILDING = 'INVESTOR_BUILDING',
  INVESTOR_BUILDING_UNITS = 'INVESTOR_BUILDING_UNITS',
  INVESTOR_BUILDING_DETAILS = 'INVESTOR_BUILDING_DETAILS',
  INVESTOR_BUILDING_TEAM = 'INVESTOR_BUILDING_TEAM',
  APPLICATION_REPORT = 'APPLICATION_REPORT',
  DEV_TOOLS = 'DEV_TOOLS',
  NOT_FOUND = 'NOT_FOUND',
}
